import { render, staticRenderFns } from "./FiltrosExterna.vue?vue&type=template&id=15037883&"
import script from "./FiltrosExterna.vue?vue&type=script&lang=js&"
export * from "./FiltrosExterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports